module.exports = __webpack_public_path__ + "static/media/no_image_user_kid_1.75120f64.png";